import { Button, Group, Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconFiles, IconTextPlus } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { ModemExcelRegModal } from './modemExcelRegModal';
import { modemApis } from '../../../../../../shared/apis/modem/apis';
import Swal from 'sweetalert2';
import { showSuccessNotification } from '../../../../../ui/notification';

interface IPropsModemRegister {
  onClickDelete: () => void;
  checkBoxArr: number[];
}

export default function ModemRegister(props: IPropsModemRegister) {
  const { onClickDelete, checkBoxArr } = props;
  const navigate = useNavigate();
  const [opened, { open, close }] = useDisclosure(false);

  const getListExcelDownload = async () => {
    try {
      showSuccessNotification('엑셀 다운로드를 시작했습니다.', '잠시만 기다려주세요.');
      // TODO: UI 개선 필요 - 다운로드 기한 및 개수 제한 방안 고려
      const res = await modemApis.getModemListExcelDownload({
        pg: 1,
        pgSize: 100000,
      });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', '모뎀 목록.xlsx');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (err) {
      Swal.fire({
        icon: 'error',
        title: '엑셀 다운로드 실패',
        text: '엑셀 다운로드에 실패했습니다.',
        confirmButtonText: '확인',
      });
    }
  };

  return (
    <>
      <Group gap="xs">
        <Menu shadow="md" width={114} position="bottom">
          <Menu.Target>
            <Button variant="filled" color="secondary.5">
              등록
            </Button>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item
              fw="normal"
              leftSection={<IconTextPlus size={18} />}
              onClick={() => navigate('/admin/management/modem/register')}
            >
              개별 등록
            </Menu.Item>
            <Menu.Item fw="normal" leftSection={<IconFiles size={18} />} onClick={open}>
              엑셀 등록
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
        <Button variant="outline" onClick={onClickDelete} disabled={checkBoxArr.length === 0}>
          선택 삭제
        </Button>
        <Button variant="default" onClick={getListExcelDownload}>
          엑셀 다운로드
        </Button>
      </Group>
      {opened && <ModemExcelRegModal opened={opened} close={close} header="모뎀 등록" />}
    </>
  );
}
